import React from 'react';
import { Button, Box } from '@mui/material';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { styled } from '@mui/system';

const OperationButton = styled(Button)(({ theme, selected }) => ({
  borderRadius: '50%',
  // border: `2px dashed white`,
  backgroundColor: selected ? theme.palette.success.main : theme.palette.warning.main,
  color: 'white',
  minWidth: 0,
  width: '35px',
  height: '35px',
  '&:hover' : { 
    backgroundColor: selected ? theme.palette.success.main : theme.palette.warning.main,
  },
  '&:active': {
    backgroundColor: selected ? theme.palette.success.main : theme.palette.warning.main,
  },
  '&:focus' : {
    backgroundColor: selected ? theme.palette.success.main : theme.palette.warning.main,
  },
}));


function OperationButtons({ handleOperationClick, selectedOperation, inactive=false }) {
  const operations = ['+', '-', '*', '/'];

  return (
    <Box
        sx={{
            display: 'flex',
            justifyContent: 'center',
            p: 1,
            m: 1,
            bgcolor: 'background.paper',
            borderRadius: 1,
        }}
    >
      <OperationButton disabled={inactive} onClick={() => handleOperationClick('undo')} sx={{mx: 0.5}}>
          <ReplayOutlinedIcon />
        </OperationButton>
      
      {operations.map((operation) => (
          <OperationButton
            disableTouchRipple
            disabled={inactive}
            key={operation}
            sx={{mx: 0.5}}
            onClick={() => handleOperationClick(operation)}
            selected={selectedOperation === operation}
          >
            {operation}
          </OperationButton>
      ))}
    </Box>
  );
}

export default OperationButtons;
